// Helpers for turning a branch's public code into a scannable QR image.
import QRCode from "qrcode";
import config from "../config/config";

// The customer-facing URL a scanned QR resolves to.
export const getTicketUrl = (code) =>
    `${config.USER_FRONTEND_BASE_URL}/getticket/${code}`;

export const generateQrDataUrl = (code) =>
    QRCode.toDataURL(getTicketUrl(code), {
        width: 300,
        margin: 2,
        color: {
            dark: "#000000",
            light: "#FFFFFF",
        },
    });

// A stored `qr_data_url` wins, but branches created before the column was
// filled in (and any whose generation failed) only ever got a `code`, so
// render the image on the fly for those instead of showing nothing.
export const resolveQrDataUrl = async (storedDataUrl, code) => {
    if (storedDataUrl) return storedDataUrl;
    if (!code) return "";

    try {
        return await generateQrDataUrl(code);
    } catch (err) {
        console.error("Error rendering QR code for code:", code, err);
        return "";
    }
};
